import { FinalInspectionItem } from '../../types/finalInspection';

export const FINAL_FORM_SAMPLE_TITLE = '제품검사성적서';
export const FINAL_FORM_SAMPLE_MEMO =
  '제품 출하 전 최종 검사에 사용합니다. 검사항목과 측정값은 제품검사 실행 시 입력합니다.';

const blankItem = (): FinalInspectionItem => ({
  itemName: '',
  standardText: '',
  methodText: '',
  sample1: '',
  sample2: '',
  sample3: '',
  sample4: '',
  sample5: '',
  judgment: '',
});

/** 실행 화면에서 행 추가로 입력. 양식/초기 화면에는 두지 않음. */
export const FINAL_INSPECTION_DEFAULT_ITEMS: FinalInspectionItem[] = [];

export function emptyFinalInspectionItem(): FinalInspectionItem {
  return blankItem();
}

export const FINAL_HEADER_META_FIELDS = [
  { label: '모델명', hint: '재고 품목 선택' },
  { label: 'LOT NO.', hint: '실행 시 입력' },
  { label: 'LOT 수량', hint: '승인 시 재고 입고 수량' },
  { label: '검사 일자', hint: '실행 시 입력' },
  { label: '검사자', hint: '실행 시 입력' },
] as const;
